<template xmlns:v-on="http://www.w3.org/1999/xhtml">
	<div>
		<headlink></headlink>
		<div class="container ui-flex ui-flex-pack-center">

			<div class="right-container ui-center 	">
				<ul class="ul-li-list ">
					<li class="ui-border-b ui-flex  ui-flex-align-center ui-flex-pack-center">
						子用户列表
					</li>
				</ul>

				<ul class="ul-li-list ">

					<li v-for="user in userList" :id="user.uId" v-on:click="addActive(user.uId)" class="ui-border-b">
						<div>{{user.uName}}</div>

						<div>
							<router-link :to="{ name:'fen', params: {uId:user.uId} }">
								<button type="button" class="btn btn-primary">添加设备</button>

							</router-link>
							<router-link :to="{ name:'quanxian', params: {uId:user.uId} }">
								<button type="button" class="btn btn-primary">分配权限</button>
							</router-link>

						</div>
					</li>
				</ul>

				<ul class="ui-tiled padding-top-100">
					<li>
						<router-link to="addUser">
							<button class="btn-little ui-flex ui-flex-pack-start pointer">
            添加
          </button>
						</router-link>
					</li>
					<li>
						<button v-on:click="showWin(true)" class="pointer btn-little ui-flex ui-flex-pack-end">
            删除
          </button>
					</li>
				</ul>
			</div>
		</div>
		<div class="alert" v-show="alertFlag">
			<div class="dialog">
				<div style="text-align: center;color:red;">{{msg}}</div>
				<div style="padding: 20px;padding-bottom: 0; text-align: center;"><button class="btn-type" v-on:click="removeUser()">确定</button><button v-on:click="showWin(false)" class="btn-type btn-close">取消</button></div>
			</div>
		</div>
	</div>
</template>

<script>
	import headlink from '@/components/common/headlink'

	export default {
		name: 'userList',
		data() {
			return {
				uid: "",
				userList: {},
				msg: "您确实是否删除改用户？",
				alertFlag: false
			}
		},
		methods: {
			showWin: function(flag) {
				if(this.uid == "") {
					return;
				}
				this.alertFlag = flag;
			},
			removeUser: function() {
				if(this.uid != "") {
					this.$http.post('/ZYun/HttpService.do', {
							"serviceCode": "1023",
							"uId": this.uid
						})
						.then((response) => {
							if(response.data.respCode == "0000") {
								this.alertFlag = false;
								const history = window.sessionStorage;
								var uid = history.getItem("user");
								this.$http.post('/ZYun/HttpService.do', {
										"serviceCode": "1022",
										"parentId": uid
									})
									.then((response) => {
										if(response.data.respCode == "0000") {
											console.log(response)
											this.userList = response.data.userList;
										} else {
											console.log(response);
										}
									})
									.catch((response) => {
										console.log(response);
									});
							} else {
								console.log(response);
							}
						})
						.catch((response) => {
							console.log(response);
						});
				}
			},
			addActive: function(uid) {
				this.uid = uid;
				$(".ul-li-list li").removeClass("active");
				$("#" + uid).addClass("active");
			}
		},
		mounted: function() {
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			this.$http.post('/ZYun/HttpService.do', {
					"serviceCode": "1022",
					"parentId": uid
				})
				.then((response) => {
					if(response.data.respCode == "0000") {
						console.log(response)
						this.userList = response.data.userList;
					} else {
						console.log(response);
					}
				})
				.catch((response) => {
					console.log(response);
				});
		},
		components: {
			headlink: headlink
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../../static/css/index.css">

</style>


// WEBPACK FOOTER //
// src/components/userManage/userList.vue